import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(username) {
  return yield oncallFetch("/api/oncall/administration/users/disable", {
    username,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/users/disable.js